export default {
  USER(state, user = {}) {
    state.user = Object.assign({}, state.user || {}, user)
  },
  HAS_TOKEN(state, boolean) {
    state.hasToken = boolean
  },
  IS_OPEN(state, boolean) {
    state.isOpen = boolean
  },
  SET_USER(state, data) {
    state.user = state.user || {}
    state.user = { ...state.user, ...data }
  },
  LOGOUT(state) {
    const customInfo = JSON.parse(localStorage.getItem('customInfo'))

    // 设置忽略Key，不要清除localStorage的值
    const ignoreClearKeys = ['isHasShowGuide', 'isHasShowPrepareTips', 'visibleWeixinGroupTips', 'visibleTeachersDaySecond', 'visibleTrainingCamp8', 'visibleNewSemester2024Receive', 'modalFlag1', 'modalFlag2', 'modalFlag3']
    const ignoreKeyValues = {}
    ignoreClearKeys.forEach(el => {
      ignoreKeyValues[el] = localStorage.getItem(el)
    })
    localStorage.clear()
    sessionStorage.clear()

    // 设置忽略的值
    for (const key in ignoreKeyValues) {
      const value = ignoreKeyValues[key]
      if (value) {
        localStorage.setItem(key, value)
      }
    }

    const { isThirdUserType1, thirdOutUrl } = state.user
    // 西安工业云第三方登录
    if (isThirdUserType1) {
      window.location.href = thirdOutUrl
      state.user = null
      state.hasToken = state.isOpen = false
      return
    }
    state.user = null
    state.hasToken = state.isOpen = false
    if (customInfo) {
      const path = customInfo.url.split('?')[0]
      if (path && /sichuan/.test(path)) {
        window.open(window.CONFIG.win_share, '_self')
        return
      }
      window.location.replace(customInfo.url)
    } else {
      window.location.replace(CONFIG.school)
    }
  },
  IS_WEAK_PASSWORD(state, boolean) {
    state.isWeakPassword = boolean
  },
  SET_CUSTOM_INFO(state, data) {
    state.customInfo = data
  },
  SET_WIN_SHARE_INFO(state, data) {
    state.winShareInfo = data
  },
  IS_FIRST(state, boolean) {
    state.isFirst = boolean
  },
  SET_DLEDC_INFO(state, data) {
    state.dledcInfo = data
  },
  SET_IS_NAV_PULL(state, data) {
    state.isNavPull = data
  },
  SET_SCHOOL_INFO(state, data) {
    state.schoolInfo = data
  },
  SET_LAST_MESSAGE(state, data) {
    state.lastMessage = data
  },
  SET_SKIP_MODAL(state, data) {
    state.skipModalVisible = data
  },
  SET_GRADE_LIST(state, data) {
    state.gradeList = data
  },
  // 批量报名 localStorage 字段设置
  HANDLE_BATCH_APPLY_GUIDE_KEY(state, isSet) {
    const key = `isHasShowGuide-${state.user.id}`
    if (isSet) {
      localStorage.setItem(key, isSet)
    } else {
      localStorage.removeItem(key)
    }
  }
}
